import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Navigate, useParams } from 'react-router-dom';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import { authRoute, localToken } from '../../utils/constants';
import { parseJSON, toJSON } from '../../utils/helpers';

const handleDownload = async (fileName) => {
  try {
    const response = await axios.post(
      `${authRoute}/gcpBucket/downloadFile`,
      { fileName },
      {
        headers: {
          responseType: 'blob', // Important for handling binary data
          Authorization: `Bearer ${localToken}`,
        },
      }
    );

    // Create a temporary URL for the blob
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error downloading file:', error);
    // Handle error (e.g., show error message to user)
  }
};

const GcpBucket = () => {
  const dispatch = useDispatch();

  const { gcpList } = useSelector((state) => state.general);

  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'gcpList',
        route: `gcpBucket/listFiles`,
      })
    );
  }, [dispatch]);

  console.log({ gcpList });
  return Array.isArray(gcpList) ? (
    <div className='p-4 mt-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center'>
        <div className='col-lg-12 d-flex justify-content-center border-bottom' data-aos='fade-up' data-aos-delay='200'>
          <h1>
            GCP Bucket: <span className='text-primary'>minemarketing-report-daily</span>
          </h1>
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        {[...gcpList].reverse().map((file) => (
          <div key={file} className='col-lg-12 d-flex justify-content-center mb-2'>
            <button className='btn btn-sm btn-outline-primary' onClick={() => handleDownload(file)}>
              {file}
            </button>
          </div>
        ))}
      </div>
    </div>
  ) : (
    <Spinner />
  );
};

export default GcpBucket;
